import React, { useState, useEffect } from "react";
import axios from "axios";
import { Star, Quote } from "lucide-react";
import { testimonials as mockTestimonials, restaurant } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import SectionBg from "./SectionBg";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const { t } = useLang();
  const [testimonials, setTestimonials] = useState(mockTestimonials);

  useEffect(() => {
    axios.get(`${API}/testimonials`)
      .then((res) => { if (Array.isArray(res.data) && res.data.length) setTestimonials(res.data); })
      .catch(() => {});
  }, []);

  return (
    <section className="relative py-24 md:py-32 bg-[#FBF7F0] overflow-hidden">
      <SectionBg section="testimonials" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#C9A24B]" />
            <span className="text-[#B0863B] tracking-[0.3em] text-xs uppercase">{t("testimonials.badge")}</span>
            <span className="h-px w-12 bg-[#C9A24B]" />
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-[#23201C] leading-tight mb-4">
            {t("testimonials.title1")} <span className="italic text-[#C9A24B]">{t("testimonials.highlight")}</span>
          </h2>
          <div className="flex items-center justify-center gap-2">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((i) => (<Star key={i} size={16} className="fill-[#C9A24B] text-[#C9A24B]" />))}
            </div>
            <span className="text-[#5a5347] text-sm">{restaurant.rating} {t("testimonials.ratingText", { n: restaurant.reviews })}</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((tt, i) => (
            <div key={i} className="relative bg-white rounded-[2px] p-7 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1.5 border border-[#efe6d4] reveal" style={{ transitionDelay: `${i * 80}ms` }}>
              <Quote className="text-[#C9A24B]/30 mb-4" size={34} />
              <p className="text-[#4f4a40] leading-relaxed mb-6 font-serif-alt text-lg">“{tt.text}”</p>
              <div className="flex items-center justify-between">
                <span className="font-display text-[#23201C]">{tt.name}</span>
                <div className="flex">
                  {Array.from({ length: tt.rating }).map((_, k) => (<Star key={k} size={13} className="fill-[#C9A24B] text-[#C9A24B]" />))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}